let csrf = '';
if (document.querySelector('meta[name="csrf-token"]')) {
  csrf = document.querySelector('meta[name="csrf-token"]').content;
}

const xhrurl = 'assets/components/nonfiction/webconnector.php';

document.addEventListener('change', function (e) {
  if (e.target.classList.contains('file') || e.target.classList.contains('fileBookPDF')){

    const fileList = e.target.files;

    if (fileList.length === 0) {
      console.log("No files selected.");
    } else {
      for (let i = 0; i < fileList.length; i++) {

        let xhr; let obj;

        e.target.nextElementSibling.classList.add('disabled', 'loading');


        const formData = new FormData();

        formData.append('image', fileList[i]);

        xhr = new XMLHttpRequest();



        xhr.open("POST", xhrurl, true);
        // xhr.setRequestHeader("Content-type", "multipart/form-data");

        xhr.setRequestHeader("Cache-Control", "no-cache");

        xhr.setRequestHeader('X-CSRF-TOKEN', csrf);
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        xhr.send(formData);

        xhr.onload = function () {

          if (xhr.status !== 200) {
            console.log(`Error ${xhr.status}: ${xhr.statusText}`); // eslint-disable-line no-console
            e.target.classList.remove('disabled', 'loading');

          } else {

            obj = JSON.parse(xhr.response);

            if (obj.success) {
              e.target.nextElementSibling.classList.remove('disabled', 'loading');
              
              let fileInfo;


              // let bookIndex = document.querySelectorAll('.form_book_n').length;

              // bookIndex = (bookIndex !== null && bookIndex !== undefined) ? bookIndex-1 : 0;
              
              const arr = Array.from(document.querySelectorAll('.form_book_n'));
              
              let bookIndex = arr.indexOf(e.target.closest('.form_book_n'));

              
              if (e.target.classList.contains('fileImage')) {
                fileInfo = `<div class="returm-box-for-image" draggable="true">
                    <img src="${obj.object.path}" class="img-return" /><br />
                    <input class="filePathPhisic" name="coverPath[${bookIndex}][]" type="hidden" value="${obj.object.path}"></input>
                    <span class="fileNamePhisic fileName" style="font-size:0.6em">${obj.object.filename}</span>
                    <button class="action removeParent" data-action="removeParent" type="button">X</button>
                  </div>`;
              } else if (e.target.classList.contains('fileBookPDF')) {
                fileInfo = `<div class="fileInfoParent">
                      <input class="filePathPhisic" name="bookPDFPath[${bookIndex}][]" type="hidden" value="${obj.object.path}"></input>
                      <span class="fileInfoText fileNamePhisic fileName">${obj.object.filename}</span>
                      <span class="action filInfoCloseButton" title="remove" data-action="removeParent">X</span>
                  </div>`;

              } else {
                fileInfo = `<div class="fileInfoParent">
                      <input class="filePathPhisic" name="`+ e.target.getAttribute('name') + `" type="hidden" value="${obj.object.path}"></input>
                      <span class="fileInfoText fileNamePhisic fileName">${obj.object.filename}</span>
                      <span class="action filInfoCloseButton" title="remove" data-action="removeParent">X</span>
                  </div>`;
              }

              if (e.target.getAttribute('multiple') === '') {
                e.target.parentNode.parentNode.querySelector('.box-for-files').insertAdjacentHTML('beforeend', fileInfo);
              } else {
                e.target.parentNode.parentNode.querySelector('.box-for-files').innerHTML = fileInfo;
              }

            }else{
              e.target.nextElementSibling.classList.remove('disabled', 'loading');

            }
          }
        }

      }
    }

  }


});